import { render, staticRenderFns } from "./AutomatedForm.vue?vue&type=template&id=4a06f62c&scoped=true&"
import script from "./AutomatedForm.vue?vue&type=script&lang=js&"
export * from "./AutomatedForm.vue?vue&type=script&lang=js&"
import style0 from "./AutomatedForm.vue?vue&type=style&index=0&id=4a06f62c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a06f62c",
  null
  
)

export default component.exports